import type { Locale } from '@/i18n';
import { localizeText } from '@/i18n/options';

export function getWeeklyTimeTableI18nProps(locale: Locale) {
  return {
    dayLabels: {
      Monday: localizeText(locale, 'Monday'),
      Tuesday: localizeText(locale, 'Tuesday'),
      Wednesday: localizeText(locale, 'Wednesday'),
      Thursday: localizeText(locale, 'Thursday'),
      Friday: localizeText(locale, 'Friday'),
      Saturday: localizeText(locale, 'Saturday'),
      Sunday: localizeText(locale, 'Sunday'),
    },
    slotLabels: {
      Morning: localizeText(locale, 'Morning'),
      Afternoon: localizeText(locale, 'Afternoon'),
      Evening: localizeText(locale, 'Evening'),
    },
    timePickerCopy: {
      titleTemplate: localizeText(locale, 'Set {slot} Time Range'),
      descriptionTemplate: localizeText(locale, 'Scroll to select start and end times for {slot}'),
      startTimeLabel: localizeText(locale, 'Start Time'),
      endTimeLabel: localizeText(locale, 'End Time'),
      cancelLabel: localizeText(locale, 'Cancel'),
      saveLabel: localizeText(locale, 'Save'),
    },
  };
}
